import { useI18n } from 'vue-i18n';
import { errorCode, errorExtension } from '@/api/client';

/** Текст ошибки API на языке пользователя по её коду; неизвестный код → общая фраза. */
export function useApiError() {
  const { t, te } = useI18n();

  function messageFor(error: unknown): string {
    const code = errorCode(error);
    if (code === 'locked_out') {
      const seconds = errorExtension<number>(error, 'retryAfterSeconds') ?? 60;
      return t('errors.locked_out', { minutes: Math.max(1, Math.ceil(seconds / 60)) });
    }
    const key = `errors.${code}`;
    return te(key) ? t(key) : t('errors.internal_error');
  }

  return { messageFor };
}
